export var ConversationDetailsLayout;
(function (ConversationDetailsLayout) {
    ConversationDetailsLayout["Overview"] = "Overview";
    ConversationDetailsLayout["Search"] = "Search";
    ConversationDetailsLayout["Sidebar"] = "Sidebar";
    ConversationDetailsLayout["SidebarCollapsed"] = "SidebarCollapsed";
    ConversationDetailsLayout["SideConversation"] = "SideConversation";
    ConversationDetailsLayout["ConversationHistory"] = "ConversationHistory";
    ConversationDetailsLayout["TeamConversation"] = "TeamConversation";
    ConversationDetailsLayout["ConversationTimeline"] = "ConversationTimeline";
    ConversationDetailsLayout["Contact"] = "Contact";
})(ConversationDetailsLayout || (ConversationDetailsLayout = {}));
